import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  transactionSummary: any;
  callback: EventEmitter<any> = new EventEmitter();
  linkedCardStatus: EventEmitter<any> = new EventEmitter();

  setTransactionSummary(transactionStatus: any) {
    this.transactionSummary = transactionStatus;
  }

  getTransactionSummary() {
    return this.transactionSummary;
  }
}
